import { useSearchResult } from '../../hooks/useSearchResult';
import { transformProductsData } from '../../utils/transformProductsData';
import type { ActualSearchProductCardProps } from '../SearchProductCard';

// TODO rename to something like useSearchResultArticles (...Products, ...Cards, or whatever)
export const useProductsData = (
  categoryDataForTracking: ActualSearchProductCardProps['categoryDataForTracking'],
  pageNumber?: number,
): { products: ActualSearchProductCardProps[]; isLoading: boolean } => {
  const { response, isLoading } = useSearchResult(pageNumber);

  return response
    ? {
        products: transformProductsData(
          response.searchresult.result.products,
          response.searchresult.information.requestCacheKey,
          categoryDataForTracking,
        ),
        isLoading,
      }
    : { products: [], isLoading };
};
